import { logger } from '@/common/api/logger';
import { parseErrorMessage } from '@/common/error';
export class ExecutionError {
  protected data?: object | string;
  name?: string;

  constructor(message: string) {
    this.name = 'ExecutionError';

    try {
      this.data = message;
    } catch (e) {
      logger.error('[COMMS_ERRORS] Failed to parse error data', { error: parseErrorMessage(e) });
      this.data = message;
    }
  }
  toString() {
    return `${this.data || 'Error during execution'}`;
  }
}

export class DoesNotExistError extends Error {
  constructor(public command: string) {
    super();
    this.name = 'DoesNotExistError';
  }
  toString() {
    return `Requested callback "${this.command}" does not exists on the chatbot.`;
  }
}

export class TimeoutError extends Error {
  constructor(public command: string) {
    super();
    this.name = 'TimeoutError';
  }
  toString() {
    return `Timed out when waiting for command ${this.command}`;
  }
}
